<template>
  <div class="entry-controls">
    <template v-if="entry.isIssued">
      <Button
        v-if="!entry.isExpired"
        v-b-popover.html="{
          content: 'Изъять ТМЦ',
          trigger: 'hover blur',
          placement: 'top',
        }"
        size="iconic"
        icon="close"
        @click="emitAction('withdraw')"
      />
      <Button
        v-else
        v-b-popover.html="{
          content: 'Списать ТМЦ',
          trigger: 'hover blur',
          placement: 'top',
        }"
        size="iconic"
        icon="box-arhive"
        @click="emitAction('discard')"
      />
    </template>
    <Button
      v-else
      v-b-popover.html="{
        content: 'Выдать ТМЦ',
        trigger: 'hover blur',
        placement: 'top',
      }"
      size="iconic"
      icon="check"
      @click="emitAction('issue')"
    />
    <template v-if="entry.isIssued">
      <Button
        :id="'inventory-item-menu-' + randomKey"
        class="inventory-item-actions-menu"
        tabindex="-1"
        size="iconic"
        icon="menu"
      />
      <b-popover
        id="inventory-item-menu-popover"
        placement="left"
        triggers="click blur"
        :target="'inventory-item-menu-' + randomKey"
      >
        <div class="popover-menu">
          <div
            class="popover-menu__item"
            @click="emitAction('showInfo')"
          >
            <svg-icon
              class="popover-menu__icon"
              color="default"
              name="file"
              :size="14"
            />
            Посмотреть описание
          </div>
          <template v-if="entry.isIssued">
            <template v-if="!entry.isExpired">
              <div
                class="popover-menu__item"
                @click="emitAction('transfer')"
              >
                <svg-icon
                  class="popover-menu__icon"
                  color="default"
                  name="user-transfer"
                  :size="14"
                />
                Передать сотруднику
              </div>
              <div
                class="popover-menu__item"
                @click="emitAction('discard')"
              >
                <svg-icon
                  class="popover-menu__icon"
                  color="default"
                  name="box-archive"
                  :size="14"
                />
                Списать
              </div>
            </template>
            <div
              v-else
              class="popover-menu__item"
              @click="emitAction('withdraw')"
            >
              <svg-icon
                class="popover-menu__icon"
                color="default"
                name="times"
                :size="14"
              />
              Изъять
            </div>
            <div
              class="popover-menu__item"
              @click="emitAction('showHistory')"
            >
              <svg-icon
                class="popover-menu__icon"
                color="default"
                name="clock-rotate-left"
                :size="14"
              />
              История действий
            </div>
          </template>
        </div>
      </b-popover>
    </template>
    <Button
      v-else
      v-b-popover.html="{
        content: 'Посмотреть описание',
        trigger: 'hover blur',
        placement: 'top',
      }"
      size="iconic"
      icon="file"
      @click="emitAction('showInfo')"
    />
  </div>
</template>

<script>

import { v4 as uuidv4 } from "uuid";

import Button from "@/components/controls2/Button";
import SvgIcon from "@/components/svg-icon";

export default {
  name: "table-entry-controls",
  components: {
    Button,
    SvgIcon,
  },
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    randomKey: null,
  }),
  created () {
    this.randomKey = uuidv4();
  },
  methods: {
    emitAction (action) {
      this.$emit(action, this.entry);
    },
  },
};
</script>

<style lang="scss" scoped>
.entry-controls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 4px;
  gap: 7px;
}
</style>